import { controls } from "../controls";

const ms445 = {
  label: "Promissory Note Entry",
  pageLabel: "Promissory Note Entry",
  starting: true,
  url: "ms444",
  bulk: { columns: ["account_number", "balance", "odamt", "d1_class", "d2_class", "d3_class", "l_a_class60", "new_od_60", "no_mrg_6"] },
  formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    //   ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({ tab: "filter", label: "Employee Code", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "employee_code", width: "col-sm-2", placeHolder: "Pf Number" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Audit Class", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "audit_class", width: "col-sm-2", placeHolder: "Audit Class" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Account Number", width: "col-sm-2" }),
    ...controls.AccountNumber({ tab: "filter", forceRender: true, beforeLeave: ["createAcNo"] }),
    ...controls.showData({ tab: "filter", data: "account_number_display", name: "account_number_display", width: "col-sm-2" }),

    //...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({ tab: "filter", label: "Crop Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "crop_name", width: "col-sm-2", placeHolder: "Crop Name" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Season", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "season", width: "col-sm-2", placeHolder: "Season" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Disbursement Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "disbursment_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Due Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "due_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Disbursement Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "disbursement_amount", width: "col-sm-2", placeHolder: "Number Only" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Intrest Rate", width: "col-sm-2" }),
    ...controls.floatOnly({ tab: "filter", name: "intrest_rate", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Renewal Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "renewal_amount", width: "col-sm-2", placeHolder: "Renewal Amount" }),

  ],


  form: [

    ...controls.displayText({ label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch" }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "CIN", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "cin", width: "col-sm-2", placeHolder: "CIN" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),


    ...controls.displayText({ tab: "filter", label: "Audit Class", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "audit_class", width: "col-sm-2", placeHolder: "Audit Class" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ label: "Account Number", width: "col-sm-2" }),
    ...controls.AccountNumber({ forceRender: true, beforeLeave: ["createAcNo"] }),
    ...controls.showData({ data: "account_number", name: "account_number", width: "col-sm-2" }),

    ...controls.displayText({ label: "Crop Name", width: "col-sm-2" }),
    ...controls.text({ name: "crop_name", width: "col-sm-2", placeHolder: "Crop Name" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ label: "Season", width: "col-sm-2" }),
    ...controls.text({ name: "season", width: "col-sm-2", placeHolder: "Season" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ label: "Disbursement Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ name: "disbursment_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ label: "Due Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ name: "due_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ label: "Disbursement Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "disbursement_amount", width: "col-sm-2", placeHolder: "Number Only" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ label: "Intrest Rate", width: "col-sm-2" }),
    ...controls.floatOnly({ name: "intrest_rate", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ label: "Renewal Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ name: "renewal_amount", width: "col-sm-2", placeHolder: "Renewal Amount" }),






  ],
  history: {
    perPage: 10,
    reportHeader: "Promissory Note Entry",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Parent  Branch",
        accessor: "parent_branch",
        width: 140,
        rwidth: 50
      },

      {
        Header: "Pf No",
        accessor: "pf_no ",
        width: 140,
        rwidth: 50
      },

      {
        Header: "Audit Class",
        accessor: "audit_class ",
        width: 140,
        rwidth: 50
      },

      {
        Header: "Account Number",
        accessor: "account_number",
        width: 140,
        rwidth: 50
      },


      {
        Header: "Crop Name",
        accessor: "Crop_name ",
        width: 140,
        rwidth: 50
      },

      {
        Header: "Season",
        accessor: "season",
        width: 140,
        rwidth: 50
      },

      {
        Header: "Disbursement Date",
        accessor: "disbursement_date ",
        width: 140,
        rwidth: 50
      },

      {
        Header: "Due Date",
        accessor: "due_date",
        width: 140,
        rwidth: 50
      },



      {
        Header: "Disbursement Amount",
        accessor: "disbursement_amount ",
        width: 140,
        rwidth: 50
      },

      {
        Header: "Intrest Rate",
        accessor: "intrest_rate",
        width: 140,
        rwidth: 50
      },

      {
        Header: "Renewal Amount",
        accesso: "renewal_amount ",
        width: 140,
        rwidth: 50
      },




    ]
  }
};

export default ms445;